<!--
 * @Author: Merlin
 * @Date: 2025-07-18 17:29:20
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-23 15:03:12
 * @Description: 
-->
<!--
    说明：
    外部传处的 width height fill 会自动加在根节点 <svg> 标签上  
    示例：
    <IconSvgUse  use="icon-hearth-empty" />
-->
<template>
    <svg class="svg-use" :class="{ size: !!size }">
        <use fill="currentColor" ref="useRef" :xlink:href="symbolHref" :href="symbolHref"></use>
    </svg>
</template>

<script>
import svgFilePath from '~/assets/svg/all-icons.svg';
import hiloIconFile from '@/assets/svg/hilo-icons.svg';
import selectIconsFile from '@/assets/svg/select-icons.svg';
import homeSvgFile from '@/assets/svg/home.svg';
import corgiwildSvg from '@/assets/svg/corgiwild-icons.svg';

// “可用图标名” 列表
export const aIconNames = [
    "icon-vote",
    "icon-wait",
    "icon-info2",
    "icon-swap2",
    "icon-info3",
    "icon-olympics",
    "icon-gaelic-sports",
    "icon-horse-racing",
    "icon-formula-1",
    "icon-chess",
    "icon-badminton",
    "icon-darts",
    "icon-cricket",
    "icon-table-tennis",
    "icon-snooker",
    "icon-specials",
    "icon-cycling",
    "icon-american-football",
    "icon-winter-sports",
    "icon-aussie-rules",
    "icon-rugby",
    "icon-motosport",
    "icon-boxing",
    "icon-golf",
    "icon-floorball",
    "icon-handball",
    "icon-tennis",
    "icon-ice-hockey",
    "icon-baseball",
    "icon-basketball",
    "icon-soccer",
    "icon-bet-slip",
    "icon-virtual-sport",
    "icon-mma",
    "icon-dota-2",
    "icon-counter-strike",
    "icon-esport",
    "icon-rally",
    "clip0_463_7132",
    "icon-aquatics",
    "icon-rugby-league",
    "icon-waterpolo",
    "icon-pool",
    "icon-field-hockey",
    "icon-volleyball",
    "icon-sport2",
    "icon-loading",
    "icon-font",
    "icon-gif",
    "icon-metamask",
    "icon-google-auth",
    "icon-binance",
    "icon-tronwallet",
    "icon-tronwallet-new",
    "icon-coin98-new",
    "icon-coin98",
    "icon-chat-ban-info",
    "icon-vip-crown-orange",
    "icon-data-hidden",
    "icon-chat-close-reply-mode",
    "icon-tips",
    "like-heart",
    "icon-link",
    "icon-link-gray",
    "icon-lock-vault",
    "icon-locked",
    "icon-locked-new",
    "icon-livechat",
    "icon-chairs",
    "icon-dollar",
    "icon-clock",
    "icon-curve-arrow",
    "icon-all-games-full",
    "icon-casino",
    "icon-sport",
    "icon-fairness",
    "icon-rating",
    "icon-sound-on",
    "icon-sound-off",
    "icon-datepicker",
    "icon-info",
    "icon-info-circle",
    "icon-info-circle-2",
    "icon-star-full",
    "icon-star-half",
    "icon-star",
    "icon-close",
    "icon-fullscreen",
    "icon-wide",
    "icon-table-user",
    "icon-question",
    "icon-question-1",
    "icon-arrow",
    "icon-arrow-arrow-right",
    "icon-email",
    "icon-speed",
    "icon-rules",
    "icon-animation",
    "icon-hotkeys",
    "icon-calendar",
    "icon-campaign",
    "icon-plus-rounded",
    "icon-error-triangle",
    "icon-pen",
    "icon-blocked-bonus",
    "icon-trash",
    "icon-sharing",
    "icon-arrow-down",
    "icon-arrow-up",
    "icon-arrow-left",
    "icon-arrow-right",
    "icon-inhouse",
    "icon-top",
    "icon-new",
    "icon-success",
    "icon-success-2",
    "icon-providers",
    "icon-menu-cashback",
    "icon-menu-cashback2",
    "icon-menu-networks",
    "icon-menu-vip",
    "icon-menu-about",
    "icon-wallet",
    "icon-delete",
    "icon-search-new",
    "icon-settings-new",
    "icon-tourney-new",
    "icon-bonus",
    "icon-statistic",
    "icon-statistic-1",
    "icon-cup",
    "icon-chat-send",
    "icon-chat-reply",
    "icon-chat-tag",
    "icon-chat-delete",
    "icon-chat-pin",
    "icon-chat-mute",
    "icon-download",
    "icon-copy",
    "icon-update",
    "icon-arrow-down-full",
    "icon-drops-and-win",
    "icon-arrow-up-full",
    "icon-check-small",
    "icon-joystick-small",
    "icon-cross-small",
    "icon-eye-open",
    "icon-eye-close",
    "icon-chat",
    "icon-email-new",
    "icon-email-new-2",
    "icon-share",
    "icon-checkmark-circle",
    "icon-checkmark",
    "check-circle",
    "icon-timer",
    "icon-filter",
    "icon-edit",
    "icon-contacts",
    "icon-account",
    "icon-cashback",
    "icon-global-tips",
    "icon-vault",
    "icon-transaction",
    "icon-history",
    "icon-history-expired",
    "icon-sessions",
    "icon-wallet-account",
    "icon-swap",
    "icon-rain",
    "icon-bets",
    "icon-live-chat",
    "icon-share-download",
    "icon-birthday",
    "icon-secured",
    "icon-gift",
    "icon-promocode",
    "icon-telegram-auth",
    "a800",
    "icon-telegram-auth-new",
    "icon-crown",
    "icon-hearth",
    "icon-rocket",
    "icon-joystick",
    "icon-circle-arrow",
    "icon-coin-drop",
    "icon-smile",
    "icon-more",
    "icon-limbo",
    "icon-coinflip",
    "icon-circle",
    "icon-mines",
    "icon-dice",
    "icon-furypharaoh",
    "icon-spacedice",
    "icon-plinko",
    "icon-keno",
    "icon-hilo",
    "icon-stairs",
    "icon-crash",
    "icon-cryptos",
    "icon-tower",
    "icon-corgiwild",
    "icon-triple",
    "icon-ring",
    "icon-roulette",
    "icon-slots",
    "icon-live",
    "icon-table",
    "icon-special",
    "icon-question-mark-rounded",
    "icon-earn",
    "icon-bonus-combats",
    "icon-farming",
    "icon-staking",
    "icon-boxes",
    "icon-referral",
    "icon-news",
    "icon-promotions",
    "icon-funfury-competition",
    "icon-battle",
    "icon-place-1",
    "icon-place-2",
    "icon-place-3",
    "icon-telegram",
    "icon-twitter",
    "icon-instagram",
    "icon-facebook",
    "icon-steemit",
    "icon-reddit",
    "icon-tiktok",
    "icon-discord",
    "icon-pinterest",
    "icon-bitcointalk",
    "icon-youtube",
    "icon-chat-2",
    "icon-bell-full",
    "icon-arrow-left-small",
    "icon-arrow-right-small",
    "icon-play",
    "icon-live-support",
    "icon-user",
    "icon-menu-promotions",
    "icon-hamburger",
    "icon-hamburger-default",
    "icon-hamburger-open",
    "icon-book",
    "icon-table-page",
    "icon-paylines",
    "icon-database",
    "icon-arrow-down-small",
    "icon-stop",
    "icon-mail",
    "icon-infinitely",
    "icon-indefinite",
    "icon-dice-front",
    "icon-heart-new",
    "icon-tournament",
    "icon-play-new",
    "icon-shows",
    "icon-share-win",
    "icon-dices",
    "icon-card-heart",
    "icon-fairness-new",
    "icon-rules-new",
    "icon-maximize",
    "icon-minimize",
    "icon-statistic-2",
    "icon-hearth-empty",
    "icon-hearth-full",
    "icon-sound",
    "icon-hotkeys-new",
    "icon-animation-new",
    "icon-fast-new",
    "icon-flag",
    "icon-statistic-3",
    "icon-online",
    "icon-calculator",
    "icon-money_bag",
    "icon-user2",
    "icon-coins",
    "icon-available-regions",
    "icon-unavailable-regions",
    "icon-all-bets",
    "icon-high-rollers",
    "icon-rare-wins",
    "icon-unavailable",
    "icon-round-progress",
    "icon-gamepad",
    "icon-round-dollar",
    "icon-two-users",
    "path-1-inside-1_729_195356",
    "icon-sword",
    "icon-user-left",
    "icon-user-ready",
    "clip0_713_195072",
    "icon-slot-restricted",
    "icon-debank",
    "mask0_10703_1745",
    "mask1_10703_1745",
    "icon-24",
    "icon-hidden-user",
    "icon-casino-big",
    "icon-sport-big",
    "icon-download-ref",
    "icon-speaker-ref",
    "icon-referral-commission",
    "clip0_1875_28489",
    "icon-referral-bonus",
    "icon-promo-new",
    "icon-undo",
    "icon-reset",
    "icon-stats",
    "icon-rounded-minus",
    "icon-status-close",
    "icon-info-2",
    "icon-calendar-2",
    "icon-rakeback",
    "clip0_5570_9273",
    "icon-calendar-3",
    "icon-calendar-4",
    'icon-intercom',
    'icon-arrow-top',
    'icon-my-bets',
    'icon-referral-2',
    'icon-commission',
    // ▲ 上方是原站点图标
    // 👇 下方是我们追加的图标
    "flag-en",
    "flag-cn",
    "circle-narrow",
    "live-refresh",
    "formulas-icon",
    "waves-set-btn",
    "waves-set-btn-stop-win",
    "waves-set-btn-stop-lose",
    "waves-set-btn-stop-win-lose",
    'menu-game-history',
    'menu-deposit-history',
    'corgiwild-bg',
    'cup-green',
    'boardmid-cont-top-side',
    'icon-blackjack',
    'edit-icon',
    'create-icon',
    'delete-icon',
    'add-icon',
    'draggable-icon',
    'info-icon',
    'double-arrow-up',
    'double-arrow-down',
    'icon-futures',
    'deposit-transfer-in',
    'deposit-transfer-out',
    'icon-cow',
    'icon-cow-green',
    'icon-cow-red',
    'icon-cow-blue',
    'icon-cow-white70',
    'icon-cow-55657E',
    'icon-cow-white100',
    'icon-cow-white30',
    'icon-blue-bg',
    'icon-cow-FF5252',
    'icon-flower-red',
    'icon-small-green',
    'icon-cow-banker',
    'icon-autorenew',
    'icon-timer2',
    'icon-awarding',
    'icon-chip1',
    'icon-chip2',
    'icon-chip5',
    'icon-chip10',
    'icon-chip50',
    'icon-chip100',
    'icon-chip200',
    'icon-chip500',
    'icon-information-r',
    'icon-live-casino',
    'icon-cancel',
];

if (import.meta.dev) {
    const obj = aIconNames.reduce((oResult, sCur) => {
        oResult[sCur] ??= 0;
        oResult[sCur]++;
        return oResult;
    }, {});
    const arr = []
    Object.entries(obj).forEach(cur => {
        if (cur[1] > 1) {
            arr.push(cur[0]);
        }
    });
    if (arr.length) {
        console.warn('注意，图标名重复了 ↓\n', arr.join(', '));
    }
}

export const aHiloIcons = [
    'hilo-icon-arrow-up',
    'hilo-icon-equal',
    'hilo-icon-arrow-down',
    'hilo-btn-up',
    'hilo-btn-down',
    'hilo-narrow-green',
    'hilo-narrow-red',
    // 👇扑克牌花色
    'hilo-spade',
    'hilo-club',
    'hilo-dDiamond',
    'hilo-heart',
];

export const homeSvg = [
    'home-dot-prev',
    'home-dot-next',
    'home-search-icon',
    'home-icon-preview',
    'BetCorgi-Originals-icon',
    'home-play-btn',
    'home-icon-like',
    'home-game-icon',
    'home-btn-rotate'
]
export default {
    props: {
        use: {
            type: String,
            required: true,
        },
        size: {
            type: String, // 20px
        },
        fileName: {
            type: String,
        },
    },
    data() {
        return {
            svgFilePath,
            hilo: hiloIconFile,
            select: selectIconsFile,
            home: homeSvgFile,
            corgiwild: corgiwildSvg,
            symbolHref: '', // 实际渲染用 href
        };
    },
    methods: {
        async updateHref() {
            const fullHref = `${this.svgPath}#${this.use}`;

            // Safari 检测：外部文件的 use 会报 404，不渲染
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            
            // 🔧 Chrome 85 及更早版本兼容性处理
            const chromeMatch = navigator.userAgent.match(/Chrome\/(\d+)/);
            const isOldChrome = chromeMatch && parseInt(chromeMatch[1], 10) < 90;

            // Safari 或旧版 Chrome 需要内联 SVG symbols
            if (isSafari || isOldChrome) {
                try {
                    await this.ensureSymbolsInlined(this.svgPath);
                    // 使用页面内注入的 symbol
                    this.symbolHref = `#${this.use}`;
                } catch (err) {
                    // 内联失败时仍尝试外部引用
                    console.warn(`[SvgUse] 内联 SVG 失败，回退到外部引用:`, err);
                    this.symbolHref = fullHref;
                }
            } else {
                this.symbolHref = fullHref;
            }

            // 更新 use 节点属性（兼容旧浏览器）
            const useEl = this.$refs.useRef;
            if (useEl) {
                useEl.setAttribute('xlink:href', this.symbolHref);
                useEl.setAttribute('href', this.symbolHref);
            }
        },
        async ensureSymbolsInlined(svgUrl) {
            // 防止重复注入
            if (document.querySelector(`[data-inline-svg="${svgUrl}"]`)) return;

            try {
                const res = await fetch(svgUrl);
                // 🔧 检查响应状态，处理 500/502 等错误
                if (!res.ok) {
                    throw new Error(`HTTP ${res.status}: ${res.statusText}`);
                }
                const text = await res.text();

                // 创建一个完全隔离的 <svg> 容器
                const container = document.createElement('svg');
                container.setAttribute('data-inline-svg', svgUrl);
                container.setAttribute('aria-hidden', 'true');
                container.setAttribute('focusable', 'false');

                // ✅ 隐藏且不影响布局
                Object.assign(container.style, {
                    position: 'absolute',
                    width: '0',
                    height: '0',
                    overflow: 'hidden',
                    visibility: 'hidden',
                    pointerEvents: 'none',
                    zIndex: '-1',
                });

                // 只取 <symbol> 内容（去掉外层 <svg> 标签）
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;
                const innerSvg = tempDiv.querySelector('svg');
                if (!innerSvg) return;

                  // 把 <symbol> 节点全部移入容器
                const symbols = innerSvg.querySelectorAll('symbol');
                symbols.forEach(sym => container.appendChild(sym));

                // ✅ 关键：添加到 <body> 最后
                document.body.appendChild(container);
            } catch (err) {
                console.warn(`[IconSvgUse] 加载 ${svgUrl} 失败:`, err);
            }
        },
    },
    computed: {
        svgPath() {
            const fileName = this.fileName;
            if (fileName && this[fileName]) {
                return this[fileName];
            }
            return this.svgFilePath;
        },
    },
    mounted() {
        this.updateHref();
    },
    watch: {
        use: 'updateHref',
        fileName: 'updateHref',
    }
};
</script>

<style>
.size {
    width: v-bind('size');
    height: v-bind('size');
    line-height: v-bind('size');
}
</style>
